import { useState } from "react";
import { Container } from "reactstrap";
import Introduction from "./Introduction/Introduction";
import LoanApplicationsOverview from "./LoanApplicationsOverview/LoanApplicationsOverview";
import ManageLoans from "./ManageLoans/ManageLoans";
import NewLoanApplication from "./NewLoanApplication/NewLoanApplication";
import RepaymentOption from "./RepaymentOption/RepaymentOption";
import styles from "./SellerFinancing.module.scss";

const SellerFinancing = () => {
  const tabs = [
    "Introduction",
    "Loan Applications Overview",
    "Loans Management",
    "New Loan Application",
    "Repayment Option",
  ];
  const [activeTab, setActiveTab] = useState(tabs[0]);

  return (
    <div 
      className={styles.sellerFinancingContainer}
    >
      <Container fluid className="p-0">
        <h4 className={styles.mainHeading}>Seller Financing</h4>

        <div className="d-flex gap-4 border-bottom border-subtle-secondary mb-3 overflow-x-auto text-nowrap">
          {tabs.map((tab) => (
            <div
              className="fw-medium"
              style={{
                color: tab === activeTab ? "#EC7426" : "black",
                cursor: "pointer",
                transition: "color .3s ease",
                fontSize: "1.25rem",
                padding: ".5rem 0rem",
              }}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </div>
          ))}
        </div>

        {activeTab === "Introduction" && <Introduction />}
        {activeTab === "Loan Applications Overview" && <LoanApplicationsOverview />}
        {activeTab === "Loans Management" && <ManageLoans />}
        {activeTab === "New Loan Application" && <NewLoanApplication />}
        {activeTab === "Repayment Option" && <RepaymentOption />}

      </Container>
    </div>
  );
};

export default SellerFinancing;